"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useUpsell = void 0;

var _tslib = require("tslib");

var _reactQuery = require("react-query");

var _map2 = _interopRequireDefault(require("lodash/map"));

var _isArray2 = _interopRequireDefault(require("lodash/isArray"));

var _find2 = _interopRequireDefault(require("lodash/find"));

var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));

var _api = require("../api");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useUpsell = function useUpsell() {
  var queryClient = (0, _reactQuery.useQueryClient)();
  return (0, _reactQuery.useMutation)(function (req) {
    return (0, _tslib.__awaiter)(void 0, void 0, void 0, function () {
      var upsell, menu, menuItem_1;
      return (0, _tslib.__generator)(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , (0, _api.fetchUpsell)(req)];

          case 1:
            upsell = _a.sent();
            menu = queryClient.getQueryData("Menu"
            /* Menu */
            );

            if (menu === null || menu === void 0 ? void 0 : menu.menuTypes) {
              menuItem_1 = (0, _flatMap2["default"])(menu.menuTypes, function (_a) {
                var menuItems = _a.menuItems;
                return (0, _tslib.__spreadArrays)(menuItems);
              });
              return [2
              /*return*/
              , (0, _map2["default"])(upsell.items, function (item) {
                var upsellItem = (0, _find2["default"])(menuItem_1, {
                  menuItemCode: item.menuItemCode
                });
                return (0, _tslib.__assign)((0, _tslib.__assign)({}, upsellItem), {
                  imageUrl: item.image
                });
              })];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  }, {
    onSuccess: function onSuccess(data, values) {
      if ((0, _isArray2["default"])(data) && data.length) {
        queryClient.setQueryData(["Upsell"
        /* Upsell */
        , values.locationNumber], data);
      }
    }
  });
};

exports.useUpsell = useUpsell;